const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Серебряные драконы — лучшие из лучших видов драконов. Они просто это понимают, понимаете?`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
